import { render, staticRenderFns } from "./DesignCard.vue?vue&type=template&id=475ca375&scoped=true"
import script from "./DesignCard.vue?vue&type=script&lang=js"
export * from "./DesignCard.vue?vue&type=script&lang=js"
import style0 from "./DesignCard.vue?vue&type=style&index=0&id=475ca375&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475ca375",
  null
  
)

export default component.exports